import React, { useState } from 'react'
import { HiOutlineArrowSmRight } from 'react-icons/hi'
import ContactModal from "../../../modal/ContactModal";
import SplitText from "../../../common/SplitText";

const heroKulfiBg = process.env.PUBLIC_URL + '/images/hero-kulfi-bg.webp';

export default function Banner() {
  const [isContactModalOpen, setIsContactModalOpen] = useState(false);

  const scrollToFranchise = () => {
    const el = document.querySelector('.franchise-section');
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div className='relative z-[20] w-full min-h-[100vh] sm:min-h-[880px] lg:min-h-[960px] xl:min-h-[1060px] flex flex-col justify-center items-center pt-[160px] sm:pt-[210px] lg:pt-[240px] xl:pt-[270px] pb-[120px] sm:pb-[170px] lg:pb-[200px] xl:pb-[240px] overflow-hidden'>
      {/* Generated Kulfi Hero Background Image */}
      <div className='absolute inset-0 z-0 pointer-events-none'>
        <img 
          src={heroKulfiBg} 
          alt='Artisanal Rainbow Trucks Kulfi' 
          className='w-full h-full object-cover object-[center_top] sm:object-[center_20%] scale-105' 
          loading='eager' 
        />
        {/* Sleek Dark / Black Overlay */}
        <div className='absolute inset-0 bg-gradient-to-b from-black/85 via-black/60 to-black/90' />
        <div className='absolute inset-0 bg-black/20' />
      </div>

      {/* Hero Content */}
      <div className='relative z-10 w-11/12 max-w-[1280px] mx-auto text-center px-[16px] sm:px-0 flex flex-col items-center justify-center'>
        
        {/* Animated Main Title with Rainbow Opportunity */}
        <SplitText
          text="A Proven, Scalable Kulfi Franchise Business Opportunity"
          tag="h1"
          className="text-[#FFFFFF] text-[28px] sm:text-[40px] md:text-[48px] lg:text-[56px] xl:text-[64px] font-extrabold leading-[1.18] max-w-[1240px] mx-auto drop-shadow-lg tracking-hero"
          delay={30}
          duration={0.7}
          ease="power3.out"
          splitType="words, chars"
          from={{ opacity: 0, y: 35 }}
          to={{ opacity: 1, y: 0 }}
          threshold={0.05}
          rootMargin="0px"
          textAlign="center"
        />

        {/* Subtitle */}
        <p className='mt-[16px] sm:mt-[24px] text-[#F1F5F9] text-[15px] sm:text-[18px] lg:text-[21px] font-normal leading-relaxed max-w-[840px] mx-auto text-shadow font-poppins font-sans'>
          Start your own kulfi business with a trusted, profitable model. Low investment, high returns, and all the operational support you need to succeed!
        </p>

        {/* CTA Buttons */}
        <div className='flex flex-wrap justify-center items-center gap-[14px] sm:gap-[18px] mt-[24px] sm:mt-[36px]'>
          <button 
            type='button'
            onClick={() => setIsContactModalOpen(true)}
            className='group bg-[#73C8BD] hover:bg-[#5bb8ab] active:scale-95 px-[32px] sm:px-[42px] h-[52px] sm:h-[60px] flex justify-center items-center gap-[12px] sm:gap-[16px] cursor-pointer rounded-full text-white font-bold text-[16px] sm:text-[18px] shadow-lg hover:-translate-y-0.5 transition-all duration-200'
          >
            <span>Apply for Franchise</span>
            <HiOutlineArrowSmRight className='text-[22px] sm:text-[26px] transition-transform duration-200 group-hover:translate-x-1' />
          </button>

          <button
            type='button'
            onClick={scrollToFranchise}
            className='px-[26px] sm:px-[34px] h-[52px] sm:h-[60px] flex justify-center items-center rounded-full bg-white hover:bg-gray-100 text-[#181F38] font-bold text-[15px] sm:text-[17px] shadow-lg hover:-translate-y-0.5 transition-all duration-200 cursor-pointer active:scale-95'
          >
            View Cart Models
          </button>
        </div>

      </div>

      <ContactModal 
        isOpen={isContactModalOpen} 
        onClose={() => setIsContactModalOpen(false)} 
      />
    </div>
  )
}
